<script setup lang="ts">
  import { computed } from "vue";

  const props = withDefaults(defineProps<{ groups?: Record<string, string[]>; firstName?: string }>(), {
    groups: () => ({}),
    firstName: "",
  });

  const emit = defineEmits<{ pick: [prompt: string] }>();

  const entries = computed(() => Object.entries(props.groups).filter(([, prompts]) => prompts.length));
</script>

<template>
  <div class="flex flex-1 flex-col gap-6 px-1 py-6">
    <p class="heading-title text-center">
      {{ firstName ? `Hi ${firstName}, how can I help?` : "How can I help?" }}
    </p>

    <div class="flex flex-col gap-4">
      <div
        v-for="[group, groupPrompts] in entries"
        :key="group"
        class="flex flex-col gap-0.5">
        <span class="heading-label px-2 pb-1 text-muted-foreground">{{ group }}</span>
        <button
          v-for="prompt in groupPrompts"
          :key="prompt"
          type="button"
          class="rounded-md px-2 py-1.5 text-left text-13 transition-colors hover:bg-muted"
          @click="emit('pick', prompt)">
          {{ prompt }}
        </button>
      </div>
    </div>
  </div>
</template>
